// extracted by mini-css-extract-plugin
export default {"card":"IndicadorCard_card__b6QQo","pieChart":"IndicadorCard_pieChart__qE7kD","title":"IndicadorCard_title__+e41R","indicador":"IndicadorCard_indicador__YlQUS"};